// src/lib/bs-labels-tables.ts
// Les libellés et descriptions des profils, en français. Module SANS dépendance : le
// dictionnaire français (src/lib/i18n/messages/fr.ts) les reprend, et bs-labels.ts importe
// lui-même les dictionnaires — sans cette séparation, l'import serait circulaire et les
// tables lues avant d'exister.

export const MANIPULATION_PROFILE_LABELS: Record<string, string> = {
  'techno-illusionniste':  'Complexité technique élevée',
  'promesses-saturateur':  'Inflation d\'engagements',
  'chaos-assume':          'Incohérence des positions',
  'economie-fiction':      'Projections budgétaires optimistes',
  'transferts-masques':    'Transfert de charge non explicité',
  'techno-pragmatique':    'Pragmatisme variable',
  'hypocrite-moral':       'Écart discours / comportement',
  // Les trois profils nés du calcul depuis les réserves (28/09/2026). Ils manquaient à cette
  // table, donc ils s'affichaient en identifiant technique — « merite-emprunte » — sur la page.
  // Un profil calculé sans libellé est un profil que le lecteur ne peut pas lire.
  'merite-emprunte':       'Causes extérieures non reconnues',
  'statisticien-creatif':  'Indicateur redéfini en cours de route',
  'perimetre-glissant':    'Périmètre réduit en cours de route',
  'aucun':                 'Aucun schéma récurrent identifié',
};

export const MANIPULATION_PROFILE_DESCRIPTIONS: Record<string, string> = {
  'techno-illusionniste':  'Recours marqué à des arguments techniques, au détriment de la lisibilité des contradictions de fond.',
  'promesses-saturateur':  'Multiplication d\'engagements rendant le suivi des réalisations difficile.',
  'chaos-assume':          'Positions contradictoires successives ou simultanées rendant l\'évaluation difficile.',
  'economie-fiction':      'Projections budgétaires peu étayées présentées comme réalistes.',
  'transferts-masques':    'Déplacement de charges fiscales ou sociales sans communication explicite.',
  'techno-pragmatique':    'Révision d\'engagements en cas de contrainte institutionnelle ou politique.',
  'hypocrite-moral':       'Écart documenté entre les valeurs affichées et les comportements observés.',
  'merite-emprunte':       'Résultats favorables présentés comme le produit de l\'action, sans mention des facteurs qui y ont contribué.',
  'statisticien-creatif':  'Cible présentée comme atteinte après modification de la règle de mesure.',
  'perimetre-glissant':    'Cible présentée comme atteinte après restriction de ce qu\'elle couvrait.',
  'aucun':                 'Aucun schéma systémique identifié dans les engagements analysés.',
};
